import {connect} from 'react-redux'
import ModalControlledView from '../components/ModalControlledView'

const mapDispatchToProps = {

};

const mapStateToProps = (state, ownProps) => {

  const { onNext, onClose, showModal, headerText, bodyText, noText, yesText, icon, centered } = ownProps;

  return {
    onNext, onClose, showModal, headerText, bodyText, noText, yesText, icon,
    centered: !!centered
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalControlledView)


// WEBPACK FOOTER //
// ./src/components/shared/ModalControlled/containers/ModalControlledContainer.js